import { render, staticRenderFns } from "./OpenCartStockAdd.vue?vue&type=template&id=7dddfa40&"
import script from "./OpenCartStockAdd.vue?vue&type=script&lang=js&"
export * from "./OpenCartStockAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OpenCartStockAdd.vue"
export default component.exports